export default __webpack_public_path__ + "static/media/cream-wave-2.19fd5e38.svg";